export const subtitles = {
    "1": {
        "startTime": 1.5470000000000002,
        "endTime": 4.756,
        "transcript": "I just have the one that I just loaded.",
        "translation": "I just have the one that I just loaded."
    },
    "2": {
        "startTime": 6.795,
        "endTime": 8.663,
        "transcript": "Okay, I'm rolling.",
        "translation": "Okay, I'm rolling."
    },
    "3": {
        "startTime": 9.05,
        "endTime": 15.09,
        "transcript": "Tua-ll' ak'a tamaani ayagyuallerpeni ayagalallerpeni,",
        "translation": "Back when you were a teenager and you traveled"
    },
    "4": {
        "startTime": 15.635,
        "endTime": 19.729,
        "transcript": "nunanun allanun wall'u-qaa pissuraqavet",
        "translation": "to other villages or when you went hunting,"
    },
    "5": {
        "startTime": 20.028,
        "endTime": 25.19,
        "transcript": "camek-qaa imumek irr'inarqepialriamek tangerqaqsaitellruuten",
        "translation": "did you ever see anything very strange"
    },
    "6": {
        "startTime": 25.201,
        "endTime": 32.029,
        "transcript": "wall'u-qaa niiteqaqsaitellruuten camek irr'inarqellriamek alingnarquralriamek-llu?",
        "translation": "or did you ever hear of anything strange or scary?"
    },
    "7": {
        "startTime": 34.341,
        "endTime": 40.065,
        "transcript": "Tamaani-gga waten nulirturlua tau͡gaam pillemni pillruunga.",
        "translation": "Yes, I did back when I had taken a wife."
    },
    "8": {
        "startTime": 40.065,
        "endTime": 44.006,
        "transcript": "Tua-i ayagyuallemni tuaten pillrunritua.",
        "translation": "I didn't experience that when I was teenager."
    },
    "9": {
        "startTime": 44.729,
        "endTime": 51.383,
        "transcript": "Wiinga elitnaullruanga anngairutma ping'um-llu alqama full sister-aama.",
        "translation": "My late older brother and my older sister inland, my full sister. taught me."
    },
    "10": {
        "startTime": 51.925,
        "endTime": 60.165,
        "transcript": "[Ayagayangua] elitnaurlua atama-llu ayallrani tamalkuan ucikurlua, uciklua kiingan casten͞gunrilnge'rma.",
        "translation": "When I began to travel to learn, my father would take me with them every time, take me even if I wouldn't be helpful."
    },
    "11": {
        "startTime": 60.525,
        "endTime": 68.297,
        "transcript": "Elitnaupiallrulliniatnga cakneq wiinga. Cakneq tua-i keneklua elitnaupiallrulliniatnga.",
        "translation": "They really taught me well. They taught me well out of great love."
    },
    "12": {
        "startTime": 69.829,
        "endTime": 84.943,
        "transcript": "Tua-i tuaten yuulua angturrilua. Kiituan tang angturriama anngarma taum kiimegnuk angutngulliniamegnuk ilarugapuk  tuquuratullrulliniameng tua-i.",
        "translation": "And that is how I lived growing up. Eventually when I grew older, my brother an I [traveled] by ourselves because we were the only men since many would die."
    },
    "13": {
        "startTime": 86.117,
        "endTime": 95.877,
        "transcript": "Anngarma tua-i ayauqurlua tua-i piyaurrlua tua-i ayallni tamalkuan. Casten'guvkenii tua-i.",
        "translation": "My brother would take me with him and I started going every time he traveled. I wasn't helpful with anything."
    },
    "14": {
        "startTime": 96.3,
        "endTime": 103.818,
        "transcript": "Tau͡gaam kevgartualuku keniryaurrlua-ll' kenilleq kumarcaurrluku. Tua-i tuaten anglillruunga.",
        "translation": "But I worked for him and started cooking and starting the fire to cook. That's how I grew up."
    },
    "15": {
        "startTime": 105.028,
        "endTime": 109.399,
        "transcript": "Tua-i-llu piyaurcama tua-i yuurrlua.",
        "translation": "And when I became competent, I was born. (??)"
    },
    "16": {
        "startTime": 109.809,
        "endTime": 116.799,
        "transcript": "Umyuarteqlua-llu waten piaqlua, qanraqlua waten nuliangengaitnilua.",
        "translation": "I would then think this, would say this, \"I won't get wife.\""
    },
    "17": {
        "startTime": 117.537,
        "endTime": 124.114,
        "transcript": "Cunaw' tang pinauraatnga makut ilama nuliangeciqua-gguq.",
        "translation": "It turned out, you see, that my relatives here would say to me that I would get a wife."
    },
    "18": {
        "startTime": 124.344,
        "endTime": 129.573,
        "transcript": "Pinaurtua nuliangengaitnilua. Arnat wii cakevkenaki.",
        "translation": "I would say that I wouldn't get a wife. I didn't care about women."
    },
    "19": {
        "startTime": 130.627,
        "endTime": 136.17,
        "transcript": "Cuna-wam nuliangelleq call' nuliangelarqelliniuq.",
        "translation": "It turned out that taking a wife makes one entrenched in having a wife."
    },
    "20": {
        "startTime": 137.9,
        "endTime": 144.693,
        "transcript": "Tua-i waniw' nulirtuumariama nutaan yuilqumun ayagalangama.",
        "translation": "When I had taken a wife, I would go to the wilderness more because I started regularly traveling."
    },
    "21": {
        "startTime": 147.492,
        "endTime": 150.866,
        "transcript": "Waten cunaw' piarkaulliniama.",
        "translation": "It turned out I was fated to do this."
    },
    "22": {
        "startTime": 153.113,
        "endTime": 158.313,
        "transcript": "Tua-i-llu maavet inartaqama cailkamun",
        "translation": "And then when I lay down here on the ground"
    },
    "23": {
        "startTime": 159.684,
        "endTime": 164.69,
        "transcript": "tua-ll' qavaryartua can'get-llu qukaatni waten inartaqama.",
        "translation": "I wouold fall asleep, also when I lay among the grass."
    },
    "24": {
        "startTime": 165.392,
        "endTime": 168.252,
        "transcript": "Pelatekiqerlua qilirlua.",
        "translation": "I pitched a tent over me."
    },
    "25": {
        "startTime": 169.137,
        "endTime": 173.418,
        "transcript": "Aturpagtua ala-i niiskenganglua, ii-yii ii-yaa.",
        "translation": "Oh my, I sang a song that I started hearing, <i>ii-yii ii-yaa</i>"
    },
    "26": {
        "startTime": 173.62,
        "endTime": 179.212,
        "transcript": "Cunaw' tang maa-i aturarkaulliniama.",
        "translation": "It turned out that I was supposed to sing."
    },
    "27": {
        "startTime": 179.79,
        "endTime": 190.13,
        "transcript": "Tuamtellam qamiga'rqama waten nanvam iluakun, iciw' kevneret, you know, up'nerkami kanaqlagssuraqamta.",
        "translation": "Then when I would hunt seals in the spring, in the lakes, you know the [?kevneret], when we hunt muskrats in the spring."
    },
    "28": {
        "startTime": 191.252,
        "endTime": 197.44,
        "transcript": "Qamigainanemi waten tuqlurciqaanga, \"Apaqutaaq!\"",
        "translation": "While I was spring seal hunting, it called out to me like this, <i>\"Apaqutaq!\"</i>"
    },
    "29": {
        "startTime": 197.47,
        "endTime": 203.59,
        "transcript": "Tua-i alingallaglua nutka-ll' waten imirtualuku camek tangerqataryuklua.",
        "translation": "I was started and loaded my gun thinking that I was going to see something."
    },
    "30": {
        "startTime": 204.176,
        "endTime": 209.726,
        "transcript": "Tua-i tauna piciryaraqluku. Tua-i malrurqugnek tuatnallruunga.",
        "translation": "That's how I did it. I've gone through that twice."
    },
    "31": {
        "startTime": 210.552,
        "endTime": 213.461,
        "transcript": "Malrurqugnek tuqlurciullruunga.",
        "translation": "Twice something called out to me."
    },
    "32": {
        "startTime": 214.631,
        "endTime": 220.888,
        "transcript": "Cuna-wam man'a qanrutestenka maligtaquallrat",
        "translation": "It turned out that obeying those that taught me"
    },
    "33": {
        "startTime": 221.548,
        "endTime": 229.078,
        "transcript": "Assilliniuq cakneq. Yugmek-llu wanigga umyugaanek navgillrunritaa wii.",
        "translation": "It's very good. And now, I have not destroyed a person's mindset."
    },
    "34": {
        "startTime": 229.578,
        "endTime": 231.303,
        "transcript": "Tua-i-w' inerquutamnek.",
        "translation": "According to my admonishment."
    },
    "35": {
        "startTime": 232.073,
        "endTime": 237.651,
        "transcript": "Yuum umyugaa qancurglaglua-llu qanrutesqevkenaku.",
        "translation": "For a person's mindset, they told me not to speak harshly to him."
    },
    "36": {
        "startTime": 238.685,
        "endTime": 240.418,
        "transcript": "Tuaten ayuqut yuut.",
        "translation": "That is how people are."
    },
    "37": {
        "startTime": 240.736,
        "endTime": 242.644,
        "transcript": "Yullret au͡gkut tuaten ayuqut.",
        "translation": "That is how the people back then were."
    },
    "38": {
        "startTime": 243.571,
        "endTime": 246.405,
        "transcript": "Tuaten ayuqelriamek piciryarangqertut.",
        "translation": "They have a custom like that."
    },
    "39": {
        "startTime": 248.268,
        "endTime": 254.266,
        "transcript": "Maligtaqurualluteng kenkurualluteng yuullruut. Kenkurualluteng tua-i.",
        "translation": "They lived in accordance and treating each other with love. They treated each other with love."
    },
    "40": {
        "startTime": 255.651,
        "endTime": 261.92,
        "transcript": "Wangkuk ilu'urqa-llu cakemna Tununermiu-llu cousin-aaqa-llu",
        "translation": "My iluraq, cousin, down there from Tununak and I"
    },
    "41": {
        "startTime": 262.201,
        "endTime": 269.879,
        "transcript": "tutkurlunuk (??) tan'gaurluulunuk tamameng. Nalirpuk ciuqliuga-kiq tayima. Wiinga ciuqliungatua.",
        "translation": "[?We were always together as boys]. I wonder who's older? I think I'm older."
    },
    "42": {
        "startTime": 270.548,
        "endTime": 277.761,
        "transcript": "anglillruukuk tutkurlunuk pingnatugyaurrlunuk-llu tua-i malikurlunuk tua-i.",
        "translation": "We grew up always with each other, and started going hunting with each other."
    },
    "43": {
        "startTime": 278.747,
        "endTime": 279.801,
        "transcript": "Yaa.",
        "translation": "Yes."
    },
    "44": {
        "startTime": 280.779,
        "endTime": 290.595,
        "transcript": "Tua-ll' ciuqlirmek ciuqlikacaarmi Kass'amek Kass'apiamek tangerqarraallerpeni",
        "translation": "Then the first time, the very first time you saw a Caucasian, a real Caucasian"
    },
    "45": {
        "startTime": 291.706,
        "endTime": 293.736,
        "transcript": "qaill' umyuarteqellrusit?",
        "translation": "What did you think?"
    },
    "46": {
        "startTime": 294.23,
        "endTime": 300.063,
        "transcript": "Alingellruunga Kass'aqapiamek Kayalivigmun",
        "translation": "I was scared of the real Caucasian in Kayalivik"
    },
    "47": {
        "startTime": 300.398,
        "endTime": 305.374,
        "transcript": "Kass'at ikgetqapiarallruut maan-i Alaska-mi.",
        "translation": "They were scarcly any Caucasians here in Alaska."
    },
    "48": {
        "startTime": 308.886,
        "endTime": 314.797,
        "transcript": "Kass'at Kayaligmun tua-i tekitelallrat cayaqlirmeng uksumi tekitnaurtut.",
        "translation": "The Caucasians coming to Kayalivik, the would arrive in the winter once in a while."
    },
    "49": {
        "startTime": 314.999,
        "endTime": 320.929,
        "transcript": "Acirnaurait yuut ayuqaitnek atkuita-llu ayuqkaitnek aciraquluki.",
        "translation": "They would give the people fitting names, and give them fitting names from their parkas."
    },
    "50": {
        "startTime": 321.119,
        "endTime": 324.647,
        "transcript": "Qamiqurrita-ll' ayuqait acirnaurait.",
        "translation": "They'd also give them fitting names by their heads/hair."
    },
    "51": {
        "startTime": 325.106,
        "endTime": 328.446,
        "transcript": "Qiivcuugpagneng, Nayilegnek",
        "translation": "People named Qiivcugpak [Curly], Nayilek [One with Sealskin]"
    },
    "52": {
        "startTime": 329.006,
        "endTime": 335.624,
        "transcript": "Tuaten Neqiacaagalek tuaten piaqluku. Waskie imna Neqiacagmek pitullruat.",
        "translation": "They even called Neqiacaagalek by that name. They used to call Waskie, Neqiacak."
    },
    "53": {
        "startTime": 336.555,
        "endTime": 339.711,
        "transcript": "Tauna Itertaalleq",
        "translation": "That person, Itertaalleq [One who Brought in a Lot]"
    },
    "54": {
        "startTime": 340.588,
        "endTime": 349.672,
        "transcript": "Imkut cangerlallratni tamaani ikamrarturluni, ikamararturluni-ll' tua-i kiangraan-ll' ikamrarturluni. Anguyagteńguluni tamaani.",
        "translation": "When there was an epidemic back then, he traveled by sled, and he even traveled by sled in the summer. He was a soldier then."
    },
    "55": {
        "startTime": 350.783,
        "endTime": 354.78,
        "transcript": "Una-llu cali iciw'",
        "translation": "And this, you know"
    },
    "56": {
        "startTime": 355.704,
        "endTime": 359.538,
        "transcript": "iciw' yaani elitnaurvik.",
        "translation": "You know that school over there?"
    },
    "57": {
        "startTime": 360.351,
        "endTime": 368.526,
        "transcript": "Taum yua tau͡gaam yaa taum tarenraa ingna niitelallemnek tangrraqa. Tangla'rqa elitnauristeńgullemni yaani wani.",
        "translation": "The owner, yes, I see the picture of the one I used to hear about. I used to see it when I was a teacher over there."
    },
    "58": {
        "startTime": 369.084,
        "endTime": 372.715,
        "transcript": "Kilbuk School.",
        "translation": "Kilbuk School."
    },
    "59": {
        "startTime": 372.997,
        "endTime": 376.358,
        "transcript": "Indian-auguq tauna wani Kilbuk-aaq wani.",
        "translation": "That Kilbuk [School] is of the [Bureau of] Indian [Affairs]."
    },
    "60": {
        "startTime": 376.931,
        "endTime": 379.925,
        "transcript": "Waten anguyauteqarraallruuq tauna wani.",
        "translation": "This is how he first went to war."
    },
    "61": {
        "startTime": 380.148,
        "endTime": 385.622,
        "transcript": "Imiritulriani Kilbuk-aq ingna wani, Kilbuk School-ami yaani wani.",
        "translation": "Among those who recorded over in Kilbuck School."
    },
    "62": {
        "startTime": 386.347,
        "endTime": 389.29,
        "transcript": "Tarenraa ingna wani.",
        "translation": "His picture over there."
    },
    "63": {
        "startTime": 391.753,
        "endTime": 401.305,
        "transcript": "Tua-ll' tuani elpet Kass'amek tangerqarraallerpeni qaill' umyuarteqellrusit?",
        "translation": "Then back when you first saw a Caucasian, what did you think?"
    },
    "64": {
        "startTime": 401.387,
        "endTime": 403.556,
        "transcript": "Nutaan-llu Kass'amek tangerrluten.",
        "translation": "And you saw a Caucasian for the first time."
    },
    "65": {
        "startTime": 403.562,
        "endTime": 408.964,
        "transcript": "Tua-i-wa Kass'aq tua-i waten cunaw' makut  Kass'at ayuqelriit.",
        "translation": "That Caucasian, it turned out that these Caucasians were like this."
    },
    "66": {
        "startTime": 409.458,
        "endTime": 416.35,
        "transcript": "Tua-i tangellruunga. Kass'at cali tekitaqameng tamaani taum kinguani Kass'aq-llu tua-i tauna",
        "translation": "I saw one. Also, when Caucasians came after that, that Caucasian"
    },
    "67": {
        "startTime": 416.952,
        "endTime": 427.749,
        "transcript": "qavarluni Kayalivigmi. Qasgirrlainarni pitullruut. Kass'at-llu tekitellruut qasgimun tua-i tuani qavarrlainarluteng qasgimi tua-i.",
        "translation": "He slept at Kayalivik. They only [slept] in community houses. And Caucasians arrivered there to the community house where they only slept in the community house."
    },
    "68": {
        "startTime": 429.08,
        "endTime": 431.726,
        "transcript": "Cateng imkuteng",
        "translation": "Their things"
    },
    "69": {
        "startTime": 432.338,
        "endTime": 435.756,
        "transcript": "itrunek taquateng tua-i ner'aqluteng.",
        "translation": "They would eat their provisions of [caribou skin]."
    },
    "70": {
        "startTime": 436.545,
        "endTime": 443.39,
        "transcript": "Kass'at pitaqelallruit. Imkut cururkaitnek-llu canegnek itrutnaurtut.",
        "translation": "Caucasians would catch them. They would also bring in grass for matting."
    },
    "71": {
        "startTime": 444.181,
        "endTime": 450.729,
        "transcript": "Cat tua-i cururkainek canegnek cagciluteng, ellii-llu tua-i qavarcuutni qaingani caggluki.",
        "translation": "They would spread out grass for matting, and he would spread some out in his sleeping area."
    },
    "72": {
        "startTime": 451.189,
        "endTime": 454.76,
        "transcript": "Tuaten pitullruut imkut yullret.",
        "translation": "The people back then used to do that."
    },
    "73": {
        "startTime": 456.203,
        "endTime": 462.059,
        "transcript": "Angutet alingyuunateng tua-i Kass'at ikamrat-llu waaten tekitaqameng waten ikamrak.",
        "translation": "The men wouldn't be afrais, and when Caucasians came on sleds, a sled like this"
    },
    "74": {
        "startTime": 462.376,
        "endTime": 470.89,
        "transcript": "Aklunek imarluteng canek cuyanek caayunek. Caayuutmek [?caayut-llu waten tangtullruunga. Waten qalutanek pitullruut.]",
        "translation": "They had various things, tobacco, tea. [I used to see] teapots, [and tea. They would use pitchers like this.]"
    },
    "75": {
        "startTime": 470.89,
        "endTime": 474.744,
        "transcript": "Waten imarmiutaq kiputnauraat.",
        "translation": "They would trade a mink skin like this."
    },
    "76": {
        "startTime": 476.22,
        "endTime": 479.326,
        "transcript": "Qalutnerek malruk.",
        "translation": "Two pitchers [of tea]."
    },
    "77": {
        "startTime": 480.176,
        "endTime": 482.791,
        "transcript": "Imna-llu qatellria yaggluku",
        "translation": "They would raise that white one."
    },
    "78": {
        "startTime": 484.102,
        "endTime": 486.943,
        "transcript": "aipaa-ll' wavet, waten aipaa waten.",
        "translation": "And the other here, the other like this."
    },
    "79": {
        "startTime": 487.683,
        "endTime": 490.394,
        "transcript": "Tua-i pikanrulliniluni tauna.",
        "translation": "That was how much it was worth."
    },
    "80": {
        "startTime": 490.923,
        "endTime": 493.845,
        "transcript": "Tua-i kiputaqluku tua-i imarmiutaq tuaten.",
        "translation": "They would trade that mink skin like that."
    },
    "81": {
        "startTime": 494.597,
        "endTime": 497.927,
        "transcript": "Waten qanlartut maa-i-rpak: \"Kass'at tamaani",
        "translation": "They say this now: \"Caucasians back then"
    },
    "82": {
        "startTime": 498.984,
        "endTime": 505.4,
        "transcript": "\"Akimek amllermek akiirluku yuut maani Alaska-mrmiut pilallrulliniut.\"",
        "translation": "\"They used to pay a lot of money to people here from Alaska.\""
    },
    "83": {
        "startTime": 505.765,
        "endTime": 510.304,
        "transcript": "Akii teguluku, ellaita akiit pikarkauluku",
        "translation": "They took his money, would have their money"
    },
    "84": {
        "startTime": 510.304,
        "endTime": 512.782,
        "transcript": "Akmavet ayauskunegteki tamakut.",
        "translation": "When they bring them out of states."
    },
    "85": {
        "startTime": 515.778,
        "endTime": 518.861,
        "transcript": "Tuaten pitullrulliniit cakneq.",
        "translation": "They would be committed to doing that."
    },
    "86": {
        "startTime": 521.896,
        "endTime": 527.938,
        "transcript": "Qanemciarkanka amllepiartut cakneq tua-i wiinga. Man'a-llu Alaska-q",
        "translation": "I have a great many stories to tell. And Alaska here"
    },
    "87": {
        "startTime": 528.432,
        "endTime": 532.263,
        "transcript": "Mat'um nalliini maa-i Alaska-q qaqitaqa wani.",
        "translation": "Now, I have gone everywhere in Alaska."
    },
    "88": {
        "startTime": 533.066,
        "endTime": 537.51,
        "transcript": "Alaska-mi caliunga ayagalua tua-i waniwa.",
        "translation": "Now, I work in Alaska by traveling."
    },
    "89": {
        "startTime": 537.956,
        "endTime": 548.001,
        "transcript": "Tua-ll' elpeni ciin ayagyuat nalluyagutesqenriciki yuuyararteng?",
        "translation": "Then to you, why don't you want young people to forget their way of life?"
    },
    "90": {
        "startTime": 548.603,
        "endTime": 553.094,
        "transcript": "Tua-i-wa man'a",
        "translation": "It's because of this"
    },
    "91": {
        "startTime": 553.413,
        "endTime": 555.805,
        "transcript": "man'a-gg' nunaput pitekluku,",
        "translation": "Because of our land"
    },
    "92": {
        "startTime": 556.016,
        "endTime": 557.45,
        "transcript": "man'a nunaput.",
        "translation": "Our land here."
    },
    "93": {
        "startTime": 558.567,
        "endTime": 560.689,
        "transcript": "Nalluyaguskunegteggu,",
        "translation": "If they forget it,"
    },
    "94": {
        "startTime": 562.085,
        "endTime": 568.536,
        "transcript": "ellii Kass'atun ayuqsung'ermi ayuqesciigatuq akiutailkuni.",
        "translation": "Even if he wants to be Western, he cannot be without money."
    },
    "95": {
        "startTime": 568.996,
        "endTime": 573.299,
        "transcript": "Tau͡gken Yugcetun ayuqekuni akiutaleng'ermi",
        "translation": "However, if he is traditionally Yup'ik even without money"
    },
    "96": {
        "startTime": 574.021,
        "endTime": 576.425,
        "transcript": "kaigngaunani-ll' tua-i.",
        "translation": "Neither will he be hungry."
    },
    "97": {
        "startTime": 577.287,
        "endTime": 583.344,
        "transcript": "Akiutailkuni tau͡gken tua-i qaillun pisciiganani neresciiganani-llu.",
        "translation": "Yet if he has no money, he can't do anything and can't eat."
    },
    "98": {
        "startTime": 583.915,
        "endTime": 591.237,
        "transcript": "Tuaten nalluyagutesqenrit'larput tamana pitekluku akquyuciungan. Yuuciqngaku Yuum.",
        "translation": "We don't want them to forget that because it is a promise. Because it's a Yup'ik way of life."
    },
    "99": {
        "startTime": 592.651,
        "endTime": 594.675,
        "transcript": "Tuaten tua-i.",
        "translation": "Like that."
    },
    "100": {
        "startTime": 595.975,
        "endTime": 600.302,
        "transcript": "Ava-i-qaa qanerturalqa teguararaat cali imum wan' tape-am.",
        "translation": "Is the tape still recording what I've been saying?"
    },
    "101": {
        "startTime": 600.303,
        "endTime": 602.683,
        "transcript": "Ii-i.",
        "translation": "Okay."
    },
    "102": {
        "startTime": 603.488,
        "endTime": 611.226,
        "transcript": "Tua-ll' ak'a tamaani yurarpatullratni qaillun ayuqelallruat?",
        "translation": "So, when they used to have dancing festivals long ago, what were they like?"
    },
    "103": {
        "startTime": 612.504,
        "endTime": 620.503,
        "transcript": "Yurarpatullruut imkut yuut kevgirluteng-gguq waten nunanun tuavet",
        "translation": "The people back then would have dance festivals by sending what they called an invitor to that village"
    },
    "104": {
        "startTime": 620.739,
        "endTime": 629.326,
        "transcript": "inglukameggnun. Tua-i-llu pinarikaki aqvaluki tua-i malruulutek waten tan'gaurluuk ikamrarlutek.",
        "translation": "To their competing [village]. Then when it's time, they would get them, two boys with a sled like this."
    },
    "105": {
        "startTime": 629.892,
        "endTime": 636.974,
        "transcript": "Tekiskata-ll' tua-i yurarluteng. Allanret taukut aklunek canek yuraulluteng tua-i",
        "translation": "Then when they arrived, they danced. Those guests would bring various things to give during dances."
    },
    "106": {
        "startTime": 637.211,
        "endTime": 642.055,
        "transcript": "Wii Kass'at, Kass'at pingenratgun ellangellruama",
        "translation": "Since I grew up just when Caucasians first came"
    },
    "107": {
        "startTime": 642.587,
        "endTime": 651.28,
        "transcript": "Lumarranek-ll' imkunek yurualluteng, qecigugarnek-llu qecignek, seal-at qeciitnek.",
        "translation": "During dances, they would give out cloth, and a lot of animal skins, seal skins."
    },
    "108": {
        "startTime": 651.539,
        "endTime": 654.749,
        "transcript": "Tuntunek-llu yurualluteng.",
        "translation": "They also gave caribout hides during dances."
    },
    "109": {
        "startTime": 655.03,
        "endTime": 660.65,
        "transcript": "Piyullritnek tua-i taukut nunalget",
        "translation": "Whatever that host village wanted"
    },
    "110": {
        "startTime": 660.65,
        "endTime": 664.025,
        "transcript": "Wangkuta waniw' nunalguukut maani Bethel-ami.",
        "translation": "We're a [host settlement here in Bethel."
    },
    "111": {
        "startTime": 664.853,
        "endTime": 667.204,
        "transcript": "Waniw' tuaten pitullruut.",
        "translation": "That's what they did."
    },
    "112": {
        "startTime": 667.881,
        "endTime": 674.104,
        "transcript": "Pingyugvikluki taukut tuaten pinek pisqelluki tauna piciqut.",
        "translation": "They would ask those people like that to give those things."
    },
    "113": {
        "startTime": 674.814,
        "endTime": 680.738,
        "transcript": "Tua-i-ll' yurualluteng yurarluteng. Yurarturluteng allanret pingyugvikellra tua-i.",
        "translation": "Then they would give through dancing. The guests would dance and give what was requested."
    },
    "114": {
        "startTime": 681.221,
        "endTime": 694.028,
        "transcript": "Yurarturnaurtut apellritnek imkunek yurauquneng piciatun nutegnek piciatun tua-i yurauqerluteng tua-i egalernek egatnek.",
        "translation": "They would dance and give various things that they had said, guns, dancing and giving various things, smokehole covers, pots."
    },
    "115": {
        "startTime": 694.202,
        "endTime": 699.013,
        "transcript": "Tua-i anglanaqluni. Anglanaqluni.",
        "translation": "It was fun. It was fun."
    },
    "116": {
        "startTime": 700.137,
        "endTime": 703.993,
        "transcript": "Tua-llu qaqiskata cali nunalget yurarluteng.",
        "translation": "Then when they were done, the host village would dance."
    },
    "117": {
        "startTime": 704.089,
        "endTime": 705.926,
        "transcript": "Yuraquneng cali tua-i.",
        "translation": "They did the same when they danced."
    },
    "118": {
        "startTime": 706.217,
        "endTime": 710.471,
        "transcript": "Tua-ll' taqkuneng apeqmeggnek neqluarqelluteng.",
        "translation": "Then when they were done, they had what they called a feast."
    },
    "119": {
        "startTime": 711.518,
        "endTime": 719.297,
        "transcript": "Allanret qasgimun iterciluteng, wii-gg' kana-i Kayalivigmi ellangellruama tua-i.",
        "translation": "The guests would bring in [food], at least since I grew up down in Kayalivik."
    },
    "120": {
        "startTime": 719.924,
        "endTime": 727.494,
        "transcript": "Uqunek itruqurilallrit piciatun keniranek kaugpautnek cetuarutnek.",
        "translation": "They would bring in seal oil, various cooked food, walrus, beluga."
    },
    "121": {
        "startTime": 728.153,
        "endTime": 732.567,
        "transcript": "Piciatun tua-i im' neqnek-llu keniraatnek.",
        "translation": "Various things, including cooked fish."
    },
    "122": {
        "startTime": 733.116,
        "endTime": 738.759,
        "transcript": "Allanret tua-i nuuqaitqapiarluku utercet'lallruit kingunritnun.",
        "translation": "They would let the guests go back home with absolutely nothing in need."
    },
    "123": {
        "startTime": 739.081,
        "endTime": 741.677,
        "transcript": "Tua-i tuaten pitullruut yuut.",
        "translation": "People used to do that."
    },
    "124": {
        "startTime": 741.73,
        "endTime": 743.9,
        "transcript": "Ikayuulluteng cakneq.",
        "translation": "They helped each other a lot."
    },
    "125": {
        "startTime": 744.67,
        "endTime": 746.562,
        "transcript": "Ikayuulluteng cakneq.",
        "translation": "They helped each other a lot."
    },
    "126": {
        "startTime": 747.584,
        "endTime": 750.584,
        "transcript": "Waten tua-i navertellriatun iciw'",
        "translation": "You know, it was like trading like this"
    },
    "127": {
        "startTime": 751.047,
        "endTime": 754.653,
        "transcript": "navrulluki cateng pitullruit.",
        "translation": "They would trade their things."
    },
    "128": {
        "startTime": 755.821,
        "endTime": 758.094,
        "transcript": "Ikayuulluteng tua-i waten.",
        "translation": "They helped each other like this."
    },
    "129": {
        "startTime": 760.039,
        "endTime": 764.339,
        "transcript": "Atam ca tamalkuan wii qanemcikaq amlleq qemangqaaqa waniwa.",
        "translation": "You see, I have a lot of stories to tell about everything."
    },
    "130": {
        "startTime": 767.706,
        "endTime": 774.696,
        "transcript": "Kegginaqut-mi caugat? Kegginaqunek ciin atulartat maa-i yuraraqameng ilait?",
        "translation": "But what are masks? Why do some wear masks today when they dance?"
    },
    "131": {
        "startTime": 775.195,
        "endTime": 781.054,
        "transcript": "Kegginaqulitullruut tamakut imkut maacikaat tamakut.",
        "translation": "They used to make masks, those magic things."
    },
    "132": {
        "startTime": 781.417,
        "endTime": 787.139,
        "transcript": "Pinguarluteng-gguq seal-aruarluteng wall'u neqnguarluteng.",
        "translation": "They said they were depictions of things, depictions of seals or fish."
    },
    "133": {
        "startTime": 787.581,
        "endTime": 792.806,
        "transcript": "Iciw' ava-i waten avatait pingqelalriit piciatun it'garuanek tuaten.",
        "translation": "You know, they have various things around them, even it'garuat [certain plants]."
    },
    "134": {
        "startTime": 793.281,
        "endTime": 794.858,
        "transcript": "Tuaten pitullruit.",
        "translation": "That's how they made them."
    },
    "135": {
        "startTime": 795.283,
        "endTime": 805.24,
        "transcript": "Tua-i-ll' taqkatki tuaten aturraarluki yurarraarluteng Itruka'arluteng apqiitnek makumiut. Kegginaqurluteng-llu unani pitullruut.",
        "translation": "Then when they fishing wearind them in dancing, the people from here would hold Itruka'ar [Inviting Feast]. They also called it Keggnaqurluteng [Wearing Masks] down [on the coast]."
    },
    "136": {
        "startTime": 805.825,
        "endTime": 808.907,
        "transcript": "Waten unani pitullruit Kegginaqurluteng.",
        "translation": "They called it Kegginaqurluteng [Wearing Masks] down there."
    },
    "137": {
        "startTime": 809.206,
        "endTime": 811.32,
        "transcript": "Maani-ll' Itruka'arluteng.",
        "translation": "And here they [called] it It'ruka'ar."
    },
    "138": {
        "startTime": 813.347,
        "endTime": 816.88,
        "transcript": "Tua-ll' taq'atki tamakut eggluki tua-i.",
        "translation": "Then when they were finished, they discarded them."
    },
    "139": {
        "startTime": 817.172,
        "endTime": 822.125,
        "transcript": "Imkuluteng kenkestaitnun mikelngurnun cali tunluki tamakut kegginaqut.",
        "translation": "And they would, you know, give those masks to the children they loved."
    },
    "140": {
        "startTime": 822.125,
        "endTime": 827.774,
        "transcript": "Tuaten. Yuut tang imkut qaillun qaillukuallruut cakneq.",
        "translation": "Like that. People back then had strange customs."
    },
    "141": {
        "startTime": 829.024,
        "endTime": 834.837,
        "transcript": "Maa-i tang wii tangvallemni ayagyuat-llu makut",
        "translation": "From what I've seen of these young people"
    },
    "142": {
        "startTime": 835.281,
        "endTime": 839.177,
        "transcript": "qessanqurrluteng cegganqeggiarulluteng-llu.",
        "translation": "They've become lazy and sedentary."
    },
    "143": {
        "startTime": 839.869,
        "endTime": 843.72,
        "transcript": "Cegganqellruut ayagyuat tangvallrenka wiinga.",
        "translation": "The youth I saw were active."
    },
    "144": {
        "startTime": 844.9,
        "endTime": 849.488,
        "transcript": "Tua-i pinirtaarturluteng pitullrulriit.",
        "translation": "They also had strength competitions."
    },
    "145": {
        "startTime": 849.488,
        "endTime": 858.387,
        "transcript": "Qagaani pinirtassiigurluteng. Ilangciarauqurluteng tua-i pinirtassiagurluteng. Tuaten pitullruut yullret imkut.",
        "translation": "They held strength competitions outside. They held strength competitions to tease each other. That's what people did back then."
    },
    "146": {
        "startTime": 858.937,
        "endTime": 860.977,
        "transcript": "Naspaagurluteng.",
        "translation": "They always competed."
    },
    "147": {
        "startTime": 861.289,
        "endTime": 867.951,
        "transcript": "Aqvautaqluteng-llu kiimelnge'rmeng tua-i aipateng-llu taukut friend-arrateng.",
        "translation": "They would run too, even by themselves, and with their peers, what friends they had."
    },
    "148": {
        "startTime": 868.93,
        "endTime": 876.738,
        "transcript": "Tuamtell' qip'artaarluteng. Tua-i uqinrarcetpagtaaluteng. Tua-i piciatun tua-i ayagyuat pillruut.",
        "translation": "Then they would compete by twisting [something]. They had [?speed] competitions. The young people did various things."
    },
    "149": {
        "startTime": 877.466,
        "endTime": 884.668,
        "transcript": "Unuakumi-llu qavaarayuunaki. Tamarmeng tangvallrenka tua-i qavaarayuitellruut qasgimi tamaani.",
        "translation": "And they wouldn't let them sleep in the morning. Every one I see wouldn't sleept for long in the community house back then."
    },
    "150": {
        "startTime": 884.668,
        "endTime": 889.488,
        "transcript": "Cegganqepiarluteng. Ellimerriqaniameng niicugniurluteng.",
        "translation": "They were very active. When they were told to do something, they would obey."
    },
    "151": {
        "startTime": 889.488,
        "endTime": 893.208,
        "transcript": "Tua-ll' yuk angukar ellimerriqan wall' angun",
        "translation": "Then if a person, old man, or man, asked for something to be done"
    },
    "152": {
        "startTime": 893.874,
        "endTime": 897.741,
        "transcript": "Anqerrluni-ll' tayim' ilani ciullengnaqluki.",
        "translation": "He would run out trying to go before his peers."
    },
    "153": {
        "startTime": 897.741,
        "endTime": 902.013,
        "transcript": "Atam cegganqepiallruut wii tangvallrenka.",
        "translation": "You see, the ones I saw were very active."
    },
    "154": {
        "startTime": 904.596,
        "endTime": 905.721,
        "transcript": "Tua apiit (??)",
        "translation": ""
    },
    "155": {
        "startTime": 909.656,
        "endTime": 911.966,
        "transcript": "Yuartet-mi tamakut?",
        "translation": "What about those Yup'ik songs?"
    },
    "156": {
        "startTime": 913.766,
        "endTime": 920.148,
        "transcript": "Watua yuarutnek caliangqertuten cauyaraqluten-llu.",
        "translation": "Now, you work with Yup'ik songs and you drum."
    },
    "157": {
        "startTime": 920.475,
        "endTime": 922.938,
        "transcript": "Naken elicallrusiki?",
        "translation": "Where did you learn them from?"
    },
    "158": {
        "startTime": 923.368,
        "endTime": 927.452,
        "transcript": "Tua-i-wa ellangellruama tamkuni yurarturalriani.",
        "translation": "It's because I grew up with those who always danced."
    },
    "159": {
        "startTime": 928.393,
        "endTime": 933.493,
        "transcript": "Tua-i ellangama miklua aturpagyaurtellrulliniunga cali.",
        "translation": "Since I grew up [like that], I also apparently started singing when I was small."
    },
    "160": {
        "startTime": 934.371,
        "endTime": 936.422,
        "transcript": "Tua-i",
        "translation": "So,"
    },
    "161": {
        "startTime": 936.638,
        "endTime": 941.613,
        "transcript": "wanigg' tua-i yuaruciyugngalua tua-i yuarucilua-ll' aturyukuma.",
        "translation": "I can write a song if I want to write a song and sing."
    },
    "162": {
        "startTime": 941.613,
        "endTime": 944.22,
        "transcript": "Tuamtellu ak'allapianek tamakunek.",
        "translation": "Then, those old songs too."
    },
    "163": {
        "startTime": 944.836,
        "endTime": 951.234,
        "transcript": "Waniw' atungnaqu'uryaaqua maa-irpak, maa-irpak tua-i, maa-irpak tua-i pillemni.",
        "translation": "These days, I try to sing a lot as I am doing now."
    },
    "164": {
        "startTime": 951.963,
        "endTime": 953.736,
        "transcript": "Piipill'er pingna",
        "translation": "The baby inland"
    },
    "165": {
        "startTime": 955.178,
        "endTime": 956.664,
        "transcript": "imkucirtuq",
        "translation": "He's, you know"
    },
    "166": {
        "startTime": 957.076,
        "endTime": 960.88,
        "transcript": "iciw' ak'allaat niitellni puqialami tua-i niitellni",
        "translation": "You know, the old [songs] he's heard, since he's not fluent"
    },
    "167": {
        "startTime": 960.88,
        "endTime": 966.008,
        "transcript": "niitellnguyagucetuit yuarutet allamiaqan kesianek tangvallrenka tamakut",
        "translation": "The ones I saw would get tired of hearing songs that are always sung every year."
    },
    "168": {
        "startTime": 966.25,
        "endTime": 970.12,
        "transcript": "Nutararrlainanek im' cimirturatullruut yuaruceteng.",
        "translation": "They would always replace their songs with new ones."
    },
    "169": {
        "startTime": 970.291,
        "endTime": 976.807,
        "transcript": "Allamiaqan yuarucingnaqu'urluteng allamiaqan. Tua-i tuaten pitullruut yuut.",
        "translation": "They would try to write songs every year. That's what people used to do."
    },
    "170": {
        "startTime": 977.424,
        "endTime": 980.513,
        "transcript": "Nutararrlianarnek tau͡gaam aturturluteng.",
        "translation": "They keep singing only new songs."
    },
    "171": {
        "startTime": 981.152,
        "endTime": 985.353,
        "transcript": "Allrakuq man'a nutararrlainanek yuarutet yuarucirluku.",
        "translation": "They would always have new songs for the year."
    },
    "172": {
        "startTime": 987.956,
        "endTime": 991.587,
        "transcript": "Atuuteqerkut kitek' yuaruka'armek.",
        "translation": "Please sing us a short song."
    },
    "173": {
        "startTime": 993.536,
        "endTime": 995.457,
        "transcript": "Ak'a-gguq tamaani",
        "translation": "They said that long ago"
    },
    "174": {
        "startTime": 996.038,
        "endTime": 1002.22,
        "transcript": "Unisteḿa qanrut'laqiinga, \"Kayalivigmiut-gguq qasgingqetullruut malrugnek, qasegpallraagnek.\"",
        "translation": "My late father would tell me, \"The people of Kayalivik had two community houses, two gargantuan community houses.\""
    },
    "175": {
        "startTime": 1002.551,
        "endTime": 1007.54,
        "transcript": "Aipaa-gguq aterluni [Qukutnguq], apiaa-llu-gguq Qasgirpagmek.",
        "translation": "He said one was called [?Qukutnguq], and the other was Qasgirpak."
    },
    "176": {
        "startTime": 1007.812,
        "endTime": 1011.547,
        "transcript": "Aipaa-ll' waten elanra mudhouse.",
        "translation": "And the other was dug out like a mudhouse."
    },
    "177": {
        "startTime": 1012.424,
        "endTime": 1018.288,
        "transcript": "Waten iquuk kill'utek kellia Kayalivigmiut keluatni waniwa",
        "translation": "The two ends submerged toward the water, here inland from Kayalivigmiut"
    },
    "178": {
        "startTime": 1018.533,
        "endTime": 1021.438,
        "transcript": "mengliitni nunat agtuumaluki.",
        "translation": "Touching the edge of the village."
    },
    "179": {
        "startTime": 1021.998,
        "endTime": 1024.473,
        "transcript": "Waten ayuqellruuq elalleq.",
        "translation": "The hole was like this."
    },
    "180": {
        "startTime": 1025.28,
        "endTime": 1028.791,
        "transcript": "Iquuk kisngalutek man'a-ll' qukaa alaunani.",
        "translation": "The two ends were submerged, and the middle here was visible."
    },
    "181": {
        "startTime": 1029.308,
        "endTime": 1036.361,
        "transcript": "Keluqlia tau͡gken man'a caarrluurtelliniluni can'guluni tua-i waten tua-i tayim' cataunani.",
        "translation": "The one further inland, however, became infested with grass like this with nothing [left]."
    },
    "182": {
        "startTime": 1036.619,
        "endTime": 1040.494,
        "transcript": "Tamaa-i-gguq Kayalivigmiut yugyallermeggni tamaani.",
        "translation": "They said it was back when there was a lot of people in Kayalivik."
    },
    "183": {
        "startTime": 1041.264,
        "endTime": 1047.157,
        "transcript": "Aatama qanemciquratullruakut tamaani ayagyuallemten̄i.",
        "translation": "My father always told us stories back when we were young."
    },
    "184": {
        "startTime": 1048.834,
        "endTime": 1051.528,
        "transcript": "Tua-llu Qasgirpagmiut-qaa?",
        "translation": "Now for Qasgirpagmiut?"
    },
    "185": {
        "startTime": 1051.608,
        "endTime": 1062.108,
        "transcript": "Waniw' tang wiinga-llu ak'a tamaani tamatum nalliini yuarutait nallunritanka any time ilait carralriit, carraulriit.",
        "translation": "Now, you see, I know the songs from a long time ago [and can sing] some of them anytime, a few of them."
    },
    "186": {
        "startTime": 1063.299,
        "endTime": 1068.396,
        "transcript": "\"Angaa-yii-yaa agiyaa-ii-yaa.\" Taum-llu yurarssuutiit.",
        "translation": "\"Angaa-yii-yaa agiyaa-ii-yaa.\" Then their dance movements."
    },
    "187": {
        "startTime": 1068.72,
        "endTime": 1070.885,
        "transcript": "Qasgirpagmiut-qaa.",
        "translation": "Qasgirpagmiut?"
    },
    "188": {
        "startTime": 1071.313,
        "endTime": 1076.488,
        "transcript": "Atam yurapiarrsuutii tamana waten [una qavani].",
        "translation": "Look how the real dance movements are like this [?upriver]."
    },
    "189": {
        "startTime": 1076.75,
        "endTime": 1081.622,
        "transcript": "Angaa-yii-yaa agiyaa-yii-yaa,",
        "translation": ""
    },
    "190": {
        "startTime": 1081.702,
        "endTime": 1086.293,
        "transcript": "angaa-yii-yaar agiyaa-yii-yaa,",
        "translation": ""
    },
    "191": {
        "startTime": 1086.663,
        "endTime": 1095.867,
        "transcript": "yii-ya-yaa yii-ya-yaar ayay'uuging-ayaa angaa,",
        "translation": ""
    },
    "192": {
        "startTime": 1095.989,
        "endTime": 1102.148,
        "transcript": "yii-yarranga-ye-ye-rrii-yaa ay'e-rri-ya.",
        "translation": ""
    },
    "193": {
        "startTime": 1102.845,
        "endTime": 1112.259,
        "transcript": "Mengyaq una-qaa piliyarnaurtuq, Qasgirpagmiunun piliyarnaurtuq,",
        "translation": "Mengyaq here is going to go, he's going to go [dance] in Qasgirpagmiut"
    },
    "194": {
        "startTime": 1112.458,
        "endTime": 1118.936,
        "transcript": "Qasgirpagmiut-qaa pamyuteng qiivtait yii-ya-ya,",
        "translation": "Are the people of Qasgirpak curling their tails yii-ya-ya,"
    },
    "195": {
        "startTime": 1119.279,
        "endTime": 1126.214,
        "transcript": "yii-ya-yaar ayay'uuring-ay'ara angaa,",
        "translation": ""
    },
    "196": {
        "startTime": 1126.319,
        "endTime": 1129.544,
        "transcript": "yii-ya-rranga-ye-ye-rri",
        "translation": ""
    },
    "197": {
        "startTime": 1129.724,
        "endTime": 1139.405,
        "transcript": "Tang tamakut taumi atuuciaqami-llu atuuciaqan tutgarangellermini tamakunun qanrutkenga'arrluku.",
        "translation": "You see, when he would sing for people, he started talking about it when he had grandchildren."
    },
    "198": {
        "startTime": 1139.405,
        "endTime": 1145.858,
        "transcript": "Makut-gguq Kalivigmiut tamaani",
        "translation": "He said that the people of Kayalivik back then"
    },
    "199": {
        "startTime": 1146.428,
        "endTime": 1153.47,
        "transcript": "Waten tua-i qasgik tauk' ingluklutek-llu Kevgiutullrulliniut tua-i yurarluteng waten.",
        "translation": "Those two community houses would compete with each other in the Kevgiq [Messengar Feast], dancing like this."
    },
    "200": {
        "startTime": 1153.851,
        "endTime": 1158.417,
        "transcript": "Yuraryunarqarallrulliniut kankut Kayalivigmiut.",
        "translation": "The people down in Kayalivik apparently loved to dance."
    },
    "201": {
        "startTime": 1159.109,
        "endTime": 1162.506,
        "transcript": "Yaa, tua-i tuaten ayuquq.",
        "translation": "Yes, that's what it's like."
    },
    "202": {
        "startTime": 1165.117,
        "endTime": 1170.878,
        "transcript": "Tekiqatarautiit-llu tayim' iIakelallruyaaqeput-llam imna.",
        "translation": "We also used to accompany that with dancing before the host village."
    },
    "203": {
        "startTime": 1171.427,
        "endTime": 1178.534,
        "transcript": "Imna tekiqatarautellra tua-i yurarluteng waten yagiraluteng waten.",
        "translation": "When they would dance for the host village, they would dance with arm movements like this."
    },
    "204": {
        "startTime": 1179.0,
        "endTime": 1186.982,
        "transcript": "Qemirrarmiut, qaill'... Qemirrarmiut-qaa nassitait (??) tull'uki",
        "translation": ""
    },
    "205": {
        "startTime": 1187.132,
        "endTime": 1198.374,
        "transcript": "ayaa-yura alii-yura, ayaa-yura alii-yura",
        "translation": ""
    },
    "206": {
        "startTime": 1198.374,
        "endTime": 1204.145,
        "transcript": "aye-rri-yaa aye-rri-yaa-rraa rraa",
        "translation": ""
    },
    "207": {
        "startTime": 1204.145,
        "endTime": 1215.003,
        "transcript": "ayaa-yura alii-yura, ayaa-yura alii-yaa",
        "translation": ""
    },
    "208": {
        "startTime": 1215.003,
        "endTime": 1221.494,
        "transcript": "aye-rri-yaa aye-rri-yaa-rraa rraa",
        "translation": ""
    },
    "209": {
        "startTime": 1222.582,
        "endTime": 1226.178,
        "transcript": "yugiyama",
        "translation": ""
    },
    "210": {
        "startTime": 1226.765,
        "endTime": 1229.214,
        "transcript": "Qaillun ima apallungqelria?",
        "translation": "How does the verse go again?"
    },
    "211": {
        "startTime": 1229.981,
        "endTime": 1231.713,
        "transcript": "yu- yu-",
        "translation": ""
    },
    "212": {
        "startTime": 1231.866,
        "endTime": 1238.033,
        "transcript": "Oh! yuarutiit pilliniaqa imna wani iciw' pissuutiit imna.",
        "translation": "Oh, I sang their song, you know, that they sung for a certain purpose."
    },
    "213": {
        "startTime": 1238.033,
        "endTime": 1239.878,
        "transcript": "Alartelliniunga.",
        "translation": "I made a mistake."
    },
    "214": {
        "startTime": 1240.192,
        "endTime": 1247.352,
        "transcript": "Wii imna-am nalluyaguartaqa. Tang yuarutait-llu niigartellrenka ilait nallunritpiaranka waniwa.",
        "translation": "I forgot it. You see, I know some of their songs that I heard very well."
    },
    "215": {
        "startTime": 1247.38,
        "endTime": 1251.129,
        "transcript": "Ca tamalkuan qanruteksugngaaqa ak'a tamaani. Ii-i",
        "translation": "I can talk about anything from long ago. I see."
    },
    "216": {
        "startTime": 1251.219,
        "endTime": 1251.865,
        "transcript": "Ii-i",
        "translation": "I see."
    },
    "217": {
        "startTime": 1252.608,
        "endTime": 1253.203,
        "transcript": "Ii-i",
        "translation": "Okay."
    },
    "218": {
        "startTime": 1253.228,
        "endTime": 1254.905,
        "transcript": "Tamakut-am muiqe'rtut.",
        "translation": "The [recoding] is full now."
    },
    "219": {
        "startTime": 1254.958,
        "endTime": 1256.078,
        "transcript": "Ii-i",
        "translation": "I see."
    },
    "220": {
        "startTime": 1256.082,
        "endTime": 1258.288,
        "transcript": "Quyanaqvaa cakneq. Yaa.",
        "translation": "Thank you very much. Yes."
    },
    "221": {
        "startTime": 1258.495,
        "endTime": 1266.726,
        "transcript": "Aturciqaput. Nallunaiceciiqamken atuqataqumteki. Aren. Yaa ii-i, ii-i",
        "translation": "We'll use them. I'll notify you when we're going to use them. Yes, okay, okay."
    },
    "222": {
        "startTime": 1266.946,
        "endTime": 1273.126,
        "transcript": "Ilurapiit, keggna ilurapakan kegga-i Louie ilurapakan. Yaa. Ii-i",
        "translation": "Their Ilurapak [Big Cousin], your Ilurapak out there, Louie, is your Ilurapak."
    },
    "223": {
        "startTime": 1274.041,
        "endTime": 1281.053,
        "transcript": "Cuukvagtulirmiunguuq. Wangkuk-llu keggna-ll' Kayalivigmiut kinguneqluki. Ii-i",
        "translation": "He's from Cuukvagtuli. The man out there and I are from Kayalivigmiut. I see."
    },
    "224": {
        "startTime": 1281.286,
        "endTime": 1282.397,
        "transcript": "Ii-i",
        "translation": "Yes."
    }
};